module.exports = __webpack_public_path__ + "assets/badge.6a7c2973a1a7d4817393f65c1cd14885.svg";